import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AvatarEditor from 'react-avatar-editor'

export default class ImageEditor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fileUrl: '',
      fileName: '',
      scale: 1
    }
    this.setEditorRefBound = this.setEditorRef.bind(this)
    this.onFileLoadBound = this.onFileLoad.bind(this)
    this.onZoomChangeBound = this.onZoom.bind(this)
    this.handleCancelImageBound = this.handleCancelImage.bind(this)
    this.handleSaveImageBound = this.handleSaveImage.bind(this)
  }

  setEditorRef(editor) {
    if (editor) this.editor = editor
  }

  onFileLoad(e) {
    const reader = new FileReader()
    const fileName = e.target.value.replace(/^.*[\\\/]/, '')
    reader.onload = e => {
      this.setState({
        fileUrl: e.target.result,
        fileName: fileName
      })
    }
    reader.readAsDataURL(e.target.files[0])
  }

  onZoom(e) {
    this.setState({
      scale: e.target.value
    })
  }

  render() {
    return (
      <div>
        <input
          className="file-input"
          type="file"
          onChange={this.onFileLoadBound}
          ref="fileUpload"
        />
        {this.state.fileUrl && (
          <div className="image-editor-wrapper">
            <AvatarEditor
              ref={this.setEditorRefBound}
              image={this.state.fileUrl}
              width={this.props.width}
              height={this.props.height}
              borderRadius={this.props.borderRadius}
              border={0}
              scale={this.state.scale}
            />
            <input
              className="zoom-slider"
              type="range"
              step="0.01"
              min="1"
              max="2"
              name="scale"
              defaultValue="1"
              onChange={this.onZoomChangeBound}
              style={{ width: this.props.width }}
            />
            <div id="iconSaveOptions" className="active">
              <div
                className="button btn-primary-small"
                onClick={this.handleSaveImageBound}
              >
                Save
              </div>
              <div
                className="button btn-secondary-small"
                onClick={this.handleCancelImageBound}
              >
                Cancel
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  handleSaveImage(e) {
    // If you want the image resized to the canvas size (also a HTMLCanvasElement)
    const canvasScaled = this.editor.getImageScaledToCanvas()
    const fileURL = canvasScaled.toDataURL()
    this.props.handleSaveImage(this.state.fileName, fileURL)
    this.setState({
      fileUrl: '',
      fileName: '',
      scale: 1
    })
    this.refs.fileUpload.value = ''
  }

  handleCancelImage() {
    this.setState({
      fileUrl: '',
      fileName: '',
      scale: 1
    })
    this.refs.fileUpload.value = ''
  }
}

ImageEditor.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  borderRadius: PropTypes.number,
  handleSaveImage: PropTypes.func
}

// https://github.com/mosch/react-avatar-editor



// WEBPACK FOOTER //
// ./src/components/mini/ImageEditor.js